/**
 * Component for wrapping and rendering content into a card's body
 */

import { Component, Input } from '@angular/core';
import { I18NDescriptor } from '../../uikit.interface';

@Component({
  selector: 'va-card-content',
  templateUrl: './va-card-content.component.html',
  styleUrls: ['./va-card-content.component.scss'],
})
export class VaCardContentComponent {
  @Input() title?: I18NDescriptor;
}
